<template>
  <div class="py-2 px-md-0 py-md-4">
    <b-tabs lazy nav-class="mb-1 border-bottom custom-tabs" no-nav-style>
      <b-tab active title-link-class="text-aba-secondary" @click="activeTab">
        <template #title>
          <b-icon class="mr-1" icon="search" scale="0.8" />
          <span class="d-inline-block d-md-none">{{ translations[12604] }}</span>
          <span class="d-none d-md-inline-block">{{ translations[13586] }}</span>
        </template>
        <template v-if="!isJobs && !isClusterJobs">
          <banner-component img-name="slide-1" :title="translations[12604]">
            <b-row class="w-100" no-gutters>
              <b-col cols="12" class="pb-4 px-1">
                <p class="display-1 mb-0 text-center timer text-white">
                  <ICountUp :delay="1000" :endVal="allCount" :options="options" />
                </p>
                <p class="fs-4 mb-0 text-center text-white" v-html="translations[13721]"></p>
              </b-col>
              <b-col cols="12" class="px-1 mb-1 mb-sm-0" sm="6" lg="4">
                <select-profession :border="true" :lg="true" v-model="selectProfession" />
              </b-col>
              <b-col cols="12" class="px-1" sm="6" lg="4">
                <select-location :border="true" :lg="true" v-model="selectLocation" />
              </b-col>
              <b-col cols="12" class="px-0 mt-1 mt-lg-0" lg="4">
                <b-row no-gutters>
                  <b-col cols="6" class="px-1">
                    <b-button variant="primary" size="lg" class="w-100" @click="search">{{ translations[1332] }}</b-button>
                  </b-col>
                  <b-col cols="6" class="px-1">
                    <b-button @click="searchFilter" variant="primary" size="lg" class="w-100" v-b-toggle.jobs-filter>
                      <b-icon icon="sliders" class="d-inline-block d-sm-inline-block d-lg-none"></b-icon>
                      <span class="ml-1 d-none d-sm-inline-block">{{ translations[13590] }}</span>
                    </b-button>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </banner-component>
          <h2 class="mt-2">{{ translations[13597] }}</h2>
          <jobs-information-box />
        </template>
        <div v-else class="component-widget">
          <job-component v-if="isJobs" />
          <job-component-cluster v-if="isClusterJobs" />
        </div>
      </b-tab>
      <b-tab lazy @click="activeTab">
        <template #title>
          <b-icon class="mr-1" icon="list-stars" scale="0.8" />
          <span class="d-inline-block d-md-none">{{ translations[13717] }}</span>
          <span class="d-none d-md-inline-block">{{ translations[13587] }}</span>
        </template>
        <div class="component-widget">
          <professions-component :is-cluster="isClusterJobs" v-if="!isJobs && !isMap" />
          <job-component v-if="isJobs" />
          <map-component :is-refresh="false" :is-header="true" v-if="isMap" />
        </div>
      </b-tab>
    </b-tabs>
    <jobs-filter />
    <jobs-sidebar />
    <not-auth-modal />
  </div>
</template>

<script lang="ts">
import { Component, Vue, Watch } from 'vue-property-decorator';
import BannerComponent from '@/components/BannerComponent.vue';
import ProfessionsComponent from '@/components/Home/ProfessionsComponent.vue';
import JobsFilter from '@/components/FilterSidebar/JobsFilter.vue';
import NotAuthModal from '@/components/Core/NotAuthModal.vue';
import JobComponent from '@/components/Home/JobComponent.vue';
import JobComponentCluster from '@/components/Home/JobComponentCluster.vue';
import JobsSidebar from '@/components/Home/JobsSidebar.vue';
import JobsInformationBox from '@/components/Home/JobsInformationBox.vue';
import MapComponent from '@/components/Map/MapComponent.vue';
import SelectProfession from '@/components/Widget/SelectProfession.vue';
import SelectLocation from '@/components/Widget/SelectLocation.vue';
import { ProfessionModule } from '@/store/modules/profession';
import { JobType } from '@/types/ProfessionType';
import { AppModule } from '@/store/modules/app';
import ICountUp from 'vue-countup-v2';
import { ClustersModule } from '@/store/modules/clusters';

@Component({
  components: {
    BannerComponent,
    JobsInformationBox,
    ProfessionsComponent,
    JobsFilter,
    NotAuthModal,
    JobComponent,
    JobsSidebar,
    SelectProfession,
    SelectLocation,
    ICountUp,
    MapComponent,
    JobComponentCluster,
  },
})
export default class HomeView extends Vue {
  get translations() {
    return AppModule.translation;
  }

  get isJobs() {
    return AppModule.visibleJobs;
  }

  get isClusterJobs() {
    return AppModule.visibleClusterJobs;
  }

  get isMap(): boolean {
    return AppModule.visibleMap;
  }

  get allCount(): number {
    return Number(AppModule.setting?.all_count || 0);
  }

  options = {
    useEasing: true,
    useGrouping: true,
    separator: AppModule.language === 'en' ? ',' : '.',
    decimal: '.',
    prefix: '',
    suffix: '',
  };

  // search
  get selectProfession() {
    return ProfessionModule.searchJobProfession;
  }

  set selectProfession(value: any) {
    ProfessionModule.SetSearchJobProfession(value);
    ProfessionModule.SetSearch({ obj: 'profession_id', value: value?.id || null });
  }

  get selectLocation() {
    return ProfessionModule.searchJobLocation;
  }

  set selectLocation(value: any) {
    ProfessionModule.SetSearchJobLocation(value);
    ProfessionModule.SetSearch({ obj: 'location_id', value: value?.id || null });
  }

  activeTab() {
    AppModule.SetVisibleJobs(false);
    AppModule.SetVisibleMap(false);
  }

  searchFilter() {
    ProfessionModule.SetJobType(JobType.search);
  }

  search() {
    ProfessionModule.SET_FILTER_DEFAULT();
    ProfessionModule.SET_SEARCH_DEFAULT();
    ProfessionModule.SET_PARAMS_DEFAULT();
    ProfessionModule.SetProfessionTitle('');
    ProfessionModule.SetJobType(JobType.search);
    AppModule.SetVisibleMap(false);
    AppModule.SetVisibleJobs(true);
  }

  created() {
    ProfessionModule.SetParamsDefault();
    AppModule.SetVisibleJobs(false);
    AppModule.SetVisibleMap(false);
    AppModule.SetVisibleClusterJobs(false);
    ClustersModule.ResetClusterData();
  }
}
</script>
